// extracted by mini-css-extract-plugin
export default {"textSmall":"styles_textSmall__fpl5c"};